<template>
    <div class="mt-0 w-100" style="padding-right: 75px;">
        <v-app-bar color="white" elevation="0"  height="45">
            <v-app-bar-nav-icon
                @click="drawer=true"
                class="primary--text"
                style="margin-top: -2px"
            />
            <v-toolbar-title class="primary--text">{{ title }}</v-toolbar-title>

            <c-app-home-search
                v-if="enableSearch"
                class="ml-3"
                :categories="categories"
                :search-on-focus="searchOnFocus"
            />

            <slot name="search" />

            <v-spacer v-if="enableSearch" />

            <div class="float-right" style="display: flex">
                <nav-user-menu />
            </div>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
        >
            <c-app-side-drawer @close="onCloseSide ()" />
        </v-navigation-drawer>
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import CAppSideDrawer from "@/modules/core/components/app/CAppSideDrawer";
import NavUserMenu    from "@/modules/msd/user/components/nav/NavUserMenu";
import CAppHomeSearch from "@/modules/core/components/app/CAppHomeSearch";

export default {
    name: "CAppBar",

    props: {
        title: {
            required: true,
        },

        categories: {
            required: true,
            type    : Array,
            default : function () {
                return null;
            }
        },

        searchOnFocus: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        enableSearch: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }

    },

    components: {
        CAppHomeSearch,
        CAppSideDrawer,
        NavUserMenu,
    },

    data: () => ({
        drawer : false,
    }),

    computed: {
        liftmanager() {
            return Core.role.liftmanager();
        },
    },

    methods: {
        onCloseSide () {
            this.drawer = false;
        },
    }
}
</script>

<style scoped>

::v-deep .v-overlay__scrim {
    opacity: 0.0!important;
    color: white;
}

::v-deep .v-toolbar__content,
::v-deep .v-toolbar__content i {
    font-size: 15pt;
    padding: 0;
}

::v-deep .v-toolbar__title {
    font-weight: 700;
    padding-left: 0!important;
    font-size: 15pt;
}


.nav-search-input input {
    outline: none;
    width: 100%;
}

::v-deep .v-btn__content {
    align-items: start;
}

::v-deep .v-menu__content {
    padding-left: 10px;
    padding-right: 10px;
    background-color: white;
    min-width: 16rem !important;
}

.nav-search-icon i {
    color: gray;
    font-size: 13pt;
}

::v-deep .v-navigation-drawer__content {
    overflow: hidden;
}

</style>